<template>
  <div class="subtitle-nav">

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.subtitle-nav {
  height: 60px;
  background: rgba(green, .1);
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleNav.vue